package uz.ferro.shop.pages.admin.pickup

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.icons.material.Add
import mui.material.Button
import mui.material.ButtonVariant
import mui.material.Paper
import mui.system.sx
import react.FC
import react.Props
import react.useContext
import react.useEffectOnce
import react.useState
import uz.ferro.shop.NavigationContext
import uz.ferro.shop.manager.PickupPointManager
import uz.ferro.shop.model.PickupPoint
import uz.ferro.shop.navigator.NavigationPage
import uz.ferro.shop.ui.AppTextMedium
import uz.ferro.shop.ui.HorizontalLayout
import uz.ferro.shop.ui.VerticalLayout
import uz.ferro.shop.ui.table.CellItem
import uz.ferro.shop.ui.table.HeaderItem
import uz.ferro.shop.ui.table.RowItem
import uz.ferro.shop.ui.table.TableView
import uz.ferro.shop.util.localized
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.number
import web.cssom.pct
import web.cssom.px

val AdminPickupPointList = FC<Props> {

    val navigator = useContext(NavigationContext)
    var data by useState(listOf<PickupPoint>())

    useEffectOnce {
        MainScope().launch {
            val result = PickupPointManager.getAdminPickupPoints()
            data = result
        }
    }

    VerticalLayout {
        sx {
            padding = 15.px
            height = 100.pct
        }

        HorizontalLayout {
            AppTextMedium {
                sx {
                    fontSize = 20.px
                    minWidth = 400.px
                }

                text = "Olib ketish nuqtalari"
            }

            Button {
                sx {
                    marginLeft = 200.px
                }
                variant = ButtonVariant.contained
                Add()
                onClick = {
                    navigator.openPage(NavigationPage.ADMIN_PICKUP_POINT, "new")
                }
            }
        }

        Paper {
            sx {
                width = 100.pct
                marginTop = 16.px
                overflow = Overflow.scroll
                position = Position.relative
                flexGrow = number(1.0)
            }

            TableView {
                headers = listOf(
                    HeaderItem(title = "ID", width = 120.px),
                    HeaderItem("Nomi")
                )
                items = data.map { item ->
                    RowItem(
                        key = item.id.toString(),
                        cells = listOf(
                            CellItem(item.id.toString()),
                            CellItem(item.title.localized())
                        ),
                        onItemClick = {
                            navigator.openPage(NavigationPage.ADMIN_PICKUP_POINT, item.id!!)
                        }
                    )
                }
            }
        }
    }
}